import { Component } from '@theme/component';
import {
  ThemeEvents,
  VariantUpdateEvent,
  ZoomMediaSelectedEvent,
} from '@theme/events';

export class MediaGallery extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate,
      { signal }
    );

    this.refs.zoomDialogComponent?.addEventListener(
      ThemeEvents.zoomMediaSelected,
      this.#handleZoomMediaSelected,
      { signal }
    );

    this.addEventListener('pointerdown', this.#rememberPointer, {
      capture: true,
      passive: true,
      signal,
    });

    this.addEventListener('pointermove', this.#trackPointer, {
      capture: true,
      passive: true,
      signal,
    });

    this.addEventListener('click', this.#handleImageClick, {
      capture: true,
      signal,
    });
  }

  #pointer;

  #rememberPointer = (event) => {
    this.#pointer = {
      x: event.clientX,
      y: event.clientY,
      moved: !event.isPrimary,
    };
  };

  #trackPointer = (event) => {
    if (!this.#pointer) return;

    const distance = Math.hypot(
      event.clientX - this.#pointer.x,
      event.clientY - this.#pointer.y
    );

    if (distance > 10) {
      this.#pointer.moved = true;
    }
  };

  #handleImageClick = (event) => {
    const slideshow = this.slideshow;

    if (
      !slideshow ||
      slideshow.slides?.length < 2 ||
      event.detail === 0
    ) return;

    const target = event.target;

    if (!(target instanceof Element)) return;

    if (
      target.closest(
        'button, a, input, video, deferred-media, product-model'
      )
    ) return;

    const slide = target.closest(
      'slideshow-slide.product-media-container--image'
    );

    if (!slide || !slideshow.contains(slide)) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.#pointer?.moved) return;

    const bounds = slide.getBoundingClientRect();

    if (event.clientX < bounds.left + bounds.width / 2) {
      slideshow.previous(event);
    } else {
      slideshow.next(event);
    }
  };

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

    if (!source) return;

    const newMediaGallery = source.querySelector('media-gallery');

    if (!newMediaGallery) return;

    this.replaceWith(newMediaGallery);
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(
      event.detail.index,
      undefined,
      { animate: false }
    );
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const zoomDialogMedia =
      this.refs.zoomDialogComponent?.refs.media[index];

    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(
      zoomDialogMedia
    );
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}